"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _FacilityIcon = _interopRequireDefault(require("../FacilityIcon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FacilitiesItem = function FacilitiesItem(_ref) {
  var _ref$showItemBackgrou = _ref.showItemBackground,
    showItemBackground = _ref$showItemBackgrou === void 0 ? false : _ref$showItemBackgrou,
    _ref$withGeneralStyle = _ref.withGeneralStyles,
    withGeneralStyles = _ref$withGeneralStyle === void 0 ? false : _ref$withGeneralStyle,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    children = _ref.children,
    icon = _ref.icon;
  return /*#__PURE__*/_react["default"].createElement(StyledFacilitiesItem, {
    $showItemBackground: showItemBackground,
    $withGeneralStyles: withGeneralStyles
  }, /*#__PURE__*/_react["default"].createElement(StyledFacilityIcon, {
    $size: isMobile ? 16 : 24,
    type: icon
  }), /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    $withGeneralStyles: withGeneralStyles
  }, children));
};
var StyledFacilitiesItem = _styledComponents["default"].li.withConfig({
  displayName: "FacilitiesItem__StyledFacilitiesItem",
  componentId: "sc-lgbe5p-0"
})(["display:flex;align-items:center;&::first-letter{text-transform:uppercase;}", " ", ""], function (_ref2) {
  var $showItemBackground = _ref2.$showItemBackground;
  return $showItemBackground && (0, _styledComponents.css)(["background-color:var(--background);border-radius:var(--border-radius);padding:6px 12px;"]);
}, function (_ref3) {
  var $withGeneralStyles = _ref3.$withGeneralStyles;
  return $withGeneralStyles && (0, _styledComponents.css)(["align-items:flex-start;"]);
});
var StyledLabel = _styledComponents["default"].span.withConfig({
  displayName: "FacilitiesItem__StyledLabel",
  componentId: "sc-lgbe5p-1"
})(["color:var(--black);font-size:14px;font-style:normal;font-weight:400;line-height:16px;align-self:center;", ""], function (_ref4) {
  var $withGeneralStyles = _ref4.$withGeneralStyles;
  return !$withGeneralStyles && (0, _styledComponents.css)(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
});
var StyledFacilityIcon = (0, _styledComponents["default"])(_FacilityIcon["default"]).withConfig({
  displayName: "FacilitiesItem__StyledFacilityIcon",
  componentId: "sc-lgbe5p-2"
})(["margin-right:6px;flex-shrink:0;height:", "px;"], function (_ref5) {
  var $size = _ref5.$size;
  return $size;
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(FacilitiesItem);